<template>
  <div class="common-box">
    <el-row class="row-one">
      <Reback class="row-one-fr" @click.native="returnOne"></Reback>
    </el-row>
    <div class="content">

      <h1>精准理财服务协议</h1>
      <div class="d1">甲方：甲方</div>
      <div class="d1 d2">乙方：北京展恒基金销售股份有限公司<span class="sp2">（以下简称“展恒基金”或“本公司”）</span></div>
      <div class="d3"><span class="sp4">鉴于：</span></div>
      <div class="d3 d4">1、甲方是依照中国有关法律法规及其他有关规定可以投资于证券投资基金的甲方，且甲方同意以自有合法资金按照本协议项下的约定进行证券投资基金的投资。</div>
      <div class="d3 d4">2、乙方是经中国证券监督管理委员会批准合法设立的独立基金销售机构。</div>
      <div class="d3 d4">3、乙方旗下拥有多名专业实力雄厚、投研经验丰富的证券投资基金研究人员，可以为甲方提供个性化的精准理财服务，即基金投资组合服务。乙方基于法律法规的规定，可以向甲方提供基金投资组合服务。</div>
      <div class="d3 d4">4、本协议是展恒基金与甲方就精准理财服务所签订的有效合同，请甲方仔细阅读本协议的具体内容。甲方选择“确认并同意”可接受本协议，即表示甲方和本公司签订合同并同意本协议陈述的各个事项。若甲方对本协议或其中某一条款存在异议或无法准确理解本协议的某一条款，请不要进行后续购买。<span class="sp3">甲方愿意按照本协议的约定，接受乙方进行证券投资基金的投资顾问服务并接受乙方为其提供的精准理财服务；</span>乙方愿意按照本协议的约定，在甲方提出申请时向甲方提供精准理财服务。</div>
      <div class="d3 d4">根据《合同法》、《基金法》、《证券投资基金销售管理办法》等法律法规及规范性文件的相关规定以及乙方的业务规则，就甲方委托并授权乙方进行基金投资组合服务，以及乙方接受甲方的委托和授权为甲方提供精准理财服务的相关事宜，达成本协议如下： </div>
      <div class="d3"><span class="sp4">一、定义</span></div>
      <div class="d3 d4">根据《合同法》、《基金法》、《证券投资基金销售管理办法》等法律法规及规范性文件的相关规定以及乙方的业务规则，就甲方委托并授权乙方进行基金投资组合服务，以及乙方接受甲方的委托和授权为甲方提供精准理财服务的相关事宜，达成本协议如下： </div>
      <div class="d3 d4">1、基金组合：基金组合是根据一定的投资策略或者投资目标，由若干只基金构成的基金组合，甲方认购精准理财组合产品实际上是认（申）购一系列的基金或其他理财产品，组合本身并非任何形式的金融产品或集合投资计划，甲方知晓并同意所购买的一系列基金及其具体比例。</div>
      <div class="d3 d4">2、精准理财服务：指乙方作为基金销售机构，接受甲方的委托和授权，向甲方提供配置并调整证券投资基金组合的服务。 </div>
      <div class="d3 d4">3、基金：指乙方按甲方申请并约定购买基金组合及调整组合中的开放式证券投资基金，投资基金的范围包括但不限于股票型基金、混合型基金、债券型基金、货币基金、指数基金等。 </div>
      <div class="d3 d4">4、参与信息：指甲方按照乙方要求，在提交参与申请时提供的所有信息，包括但不限于姓名、证件类型、证件号码、联系方式、在乙方开立的交易账户、风险承受能力、参与金额等事项。 </div>
      <div class="d3 d4">5、展恒精准理财服务交易账户：下称交易账户，指乙方为甲方开立的、记录甲方参与乙方展恒精准理财服务的账户。 </div>
      <div class="d3 d4">6、工作日：指上海证券交易所和深圳证券交易所的正常交易日。 </div>
      <div class="d3 d4">7、T日：指本协议约定的客户参与或退出的日期，一般指甲方提交有效的参与、追加参与申请或退出申请之日。</div>
      <div class="d3"><span class="sp4">二、委托授权</span></div>
      <div class="d3 d4">1、甲方自愿购买精准理财组合产品，充分了解并接受组合产品的配置且自愿持有基金组合。<span class="sp3">甲方同意按照本协议，接受乙方提供的基金投资组合服务，委托并授权乙方购买基金组合，并进行组合的动态调整。</span>甲方委托赎回精准理财产品将会赎回组合下全部单支基金；甲方调仓是指调整组合下各基金配置仓位的行为，调仓申请由甲方提出。请甲方确认在提出购买或调仓的委托申请前已完全知晓基金组合具体配置详情和仓位调整详情。</div>
      <div class="d3 d4">2、乙方同意接受甲方的委托和授权，按照本协议的约定，提供证券投资基金投资组合服务，且投资于乙方代理销售的证券投资基金。甲方购买精准理财组合产品后，交易金额将按照基金组合中各基金约定的仓位比例进行申购，申购成功后，甲方作为基金份额持有人持有基金的权利、义务应适应基金合同、基金招募说明书等基金交易基本文件的相应规定。</div>
      <div class="d3"><span class="sp4">三、 甲乙双方权利义务</span></div>
      <div class="d3 d4">1、甲方应按照乙方要求提供参与信息，以便乙方能够充分了解甲方的风险承受能力、基金投资需求等事项。甲方应真实、完整、准确地填写参与信息，并确保所填写的内容真实、完整准确，没有任何遗漏、错误和虚假内容。 </div>
      <div class="d3 d4">2、甲方需通过展恒基金网完成投资风险承受能力评估的相关操作。做风险测评时：根据相关法规，因金融产品有不同的风险等级，需要您完成风险测评了解自身的承受能力，便于做出理性的投资决策，防止违背意愿购买了与自身风险承受能力不匹配的产品。乙方已充分向您揭示了该智能组合的风险，您的风险承受能力、投资品种与该组合所对应的风险等级、投资品种相匹配。乙方就前述适当性评估结果与您进行确认，建议甲方审慎考虑该智能组合的风险与收益情况，选择适合自己风险承受能力的组合进行投资。</div>
      <div class="d3 d4">3、精准理财基金组合产品的风险等级并不代表组合下各基金的风险等级，甲方应充分考虑自己的风险承受能力与组合下每一只基金的风险对应情况，甲方若无法接受组合下某基金的风险，请勿继续购买。若您同意该协议，表明您已充分考虑到该组合的风险以及组合下各基金的风险，并愿意自行承担相应的风险。</div>
      <div class="d3 d4">4、甲方知悉并确认，其提交的参与信息是乙方向甲方提供展恒精准理财服务的重要依据，在本协议存续期间，甲方提供的参与信息内容发生变化的，应及时告知乙方，方便乙方为甲方重新提出适当性匹配意见。如甲方信息变更导致不适合再接受已参与的乙方展恒精准理财服务的，则甲方应听取乙方意见退出相应精准理财服务或参与其他适当的精准理财服务，如甲方不听取乙方意见的，则乙方有权对甲方所参与的不适当的精准理财服务做强制退出处理。乙方向甲方说明，如甲方接受展恒精准理财服务时未填写参与信息，乙方将不接受甲方的参与申请；如甲方填写的参与信息内容有遗漏、错误或虚假的，由此引起的后果由甲方承担。 </div>
      <div class="d3 d4">5、甲方知悉并确认，在本协议存续期间，乙方按照本协议的相关方案构建基金组合，甲方不得对乙方的组合策略进行干预，否则视为甲方退出本协议项下的展恒精准理财服务。</div>
      <div class="d3 d4">6、展恒基金系统对各种交易申请的受理并不代表该申请一定成功，而仅代表展恒系统接收到该申请，交易申请的确认以基金注册登记机构或基金管理人的最终确认结果为准。因甲方、基金组合主理人账户余额不足、账户状态不正常、银行卡存在挂失、损坏销卡等异常等原因或网络故障、系统故障等不可抗力导致交易申请失败的，展恒基金不承担责任。</div>
      <div class="d3 d4">7、展恒基金系统发出调仓信号后，乙方会通过App推送或短信方式进行通知（需要开启app－我的资产－微信通知功能），您可在app和展恒基金网页中自主选择调仓或不调仓，目标仓位持仓差异率超过40%或未在app中选择调仓或暂不调仓的客户将进行电话通知，如因短信到达率问题、未及时查看短信、手机存在停机、关机、无法接通等非展恒基金原因导致您未能及时调仓情况时，展恒基金不承担由此产生的一切责任。</div>
      <div class="d3"><span class="sp4">四、业务规则</span></div>
      <div class="d3 d4">1、甲方可通过乙方的互联网基金销售系统参与乙方的精准理财服务协议，包括精准理财产品的申购、赎回和调仓操作，精准理财业务办理方式详见乙方公告。 </div>
      <div class="d3 d4">2、甲方在工作日15:00前向乙方提出上述业务申请，甲方在乙方工作日15:00以后或非工作日提出的申请，将被视为下一个工作日提出的申请。甲方已经提交的参与、退出和调仓的申请在经乙方确认后不得撤销。 </div>
      <div class="d3 d4">3、甲方明确知悉，在组合基金的申购得到完全确认前，甲方无法提出退出申请；在甲方提出申请且乙方根据基金投资组合策略调整基金组合仓位期间，甲方也无法提出退出申请。</div>
      <div class="d3 d4">4、甲方在工作日15:00前提出的申请，通常将在下一工作日由基金公司TA进行确认；甲方在工作日15:00以后或非工作日提出的申请，通常将在下两个工作日由基金公司TA进行确认。具体以基金公司确认时间为准。</div>
      <div class="d3 d4">5、甲方买入精准理财组合仅支持采用银行卡进行支付，展恒基金遵循同卡进出原则，办理精准理财组合卖出赎回款或买入失败退款的划付。甲方参与或退出展恒精准理财服务的银行卡账户是甲方接受基金投资组合服务而交纳参与资金、展恒精准理财服务交易账户项下基金交易所涉资金收付及收取退出基金投资组合服务时资金的账户，须由甲方以其自身名义持有。 </div>
      <div class="d3 d4">6、甲方在参与展恒精准理财服务时所涉及到的基金交易、份额托管、资金监管等均按照公募基金相关流程办理。 </div>
      <div class="d3 d4">7、甲方可以向乙方申请全部退出展恒精准理财产品，但需要对该精准理财产品全部进行赎回，不得部分赎回，也不得要求乙方全部或部分赎回基金组合中指定基金的份额。甲方申请全部退出展恒精准理财产品的，乙方在收到退出申请的当个工作日，应当将甲方交易账户项下办理赎回手续，非因乙方的原因导致无法进行赎回操作的除外。如基金组合中的任何一只或多只基金发生巨额赎回或暂停赎回、转换的情形，除非乙方另有公告说明，否则，甲方、乙方应当遵守相应基金的基金合同、招募说明书或届时该基金临时公告的规定，乙方应按照巨额赎回的规定持续提出赎回申请或在暂停赎回的情形结束后及时办理相关手续。组合中基金产品的赎回结果，具体以基金公司确认的结果为准，相关风险由甲方承担。 </div>
      <div class="d3 d4">8、甲乙双方确认，乙方以甲方名义办理基金的申购、赎回、转换等交易，应符合法律法规及相应基金合同、招募说明书、基金临时公告等文件的规定。若购买精准理财组合后发生成份基金部分或全部确认失败的，展恒基金不再对失败的成份基金重新发起申购，请甲方知晓并了解相关风险。失败的交易款项，展恒基金将于2个工作日内办理退款。为保证资产配置方案的有效性、完整性、稳定性，您持有的智能组合在购买、调仓过程中，存在确认中的交易，将无法进行基金赎回操作。</div>
      <div class="d3 d4">9、乙方应基于诚实信用原则，为甲方的利益办理基金份额的申购、赎回、转换等业务，上述业务办理中涉及的申购费、赎回费、转换费及其他基金销售费用应由甲方承担，该费用由销售机构或基金公司根据基金合同、招募说明书等法律文件的规定收取。乙方可在不违反法律法规或者行业监管规则的条件下自行决定减免上述部分费用。预计金额、预计手续费以基金最新净值估算得到，仅供参考，实际交易金额、手续费以基金公司的确认为准。</div>
      <div class="d3 d4">10、乙方为甲方办理基金份额的申购且申请经基金注册登记机构确认的，甲方即为交易账户项下基金组合相应基金的基金份额持有人，享有依各基金的基金合同约定的权利并承担相应的义务。 </div>
      <div class="d3 d4">11、甲方接受展恒精准理财服务，即表示同意授权交易账户项下的一键购买基金组合及一键动态调整基金组合仓位。 展恒基金调仓通知并不意味着建议甲方进行调仓，也不意味着建议其他甲方跟随购买，若甲方进行调仓或者其他甲方跟随购买及调仓，应自行承担风险和责任。甲方不得违规宣传推介精准理财产品，不得诱导他人跟随购买精准理财基金组合、基金调仓，也不得在未具备相应资质或未经必要的许可酊备案的情况下，利用基金组合开展投资顾问活动；不得进行其他违反法律法规或本协议的行为。</div>
      <div class="d3 d4">12、甲方确定买入精准理财组合时，展恒基金将判断选定精准理财组合的风险等级是否超越甲方的风险承受能力并进行风险提示。如果甲方无法接受超出风险等级的产品，请退出购买，如您执意购买，产生的损失由甲方自行承担。<span class="sp3">甲方需明确知悉其所定制的精准理财服务的风险等级，且确认其向乙方提供的各类信息均真实、准确，其向乙方进行的风险确认均系其真实意思表示，甲方确认自愿承担投资风险。</span></div>
      <div class="d3 d4">13、为了更好地为甲方提供精准理财资产配置服务，展恒基金将跟踪市场变化并根据展恒基金的市场观点不定期对精准理财中的成份基金进行调整，以应对因市场因素及其他不可抗力因素对组合成份基金造成的影响。调仓计划将提前1-7个工作日发布预告，展恒基金具体调仓计划将通过app、网站进行发布，在发布后的第二天将允许客户进行调仓操作。调仓计划发布后，客户首先将在app、网站看到调仓提醒，对未在app和网站看到调仓提醒的客户，将通过短信或电话进行通知，同意本协议表示甲方愿意接受乙方对其发出的通知。客户可根据自己的需求以及对调仓计划的认可程度，自愿选择是否进行每一次的调仓，调仓申请由客户主动申请。针对不同意展恒调仓计划的甲方，可不进行调仓，如甲方不同意但申请调仓产生的后果和损失由本人自愿承担。针对同意展恒基金观点的甲方，展恒基金将为甲方提供一键调仓服务，客户在调仓前需仔细阅读展恒基金的调仓计划和具体调整仓位，主动且自愿点击调仓按钮。在执行“调整仓位”时，展恒基金将根据本期观点，对甲方的组合成份基金于当日（T日）发起组合内部成份基金的份额赎回，在份额得到确认时对加仓的基金进行申购，并将当前组合配比调整至当次目标组合配比。基金进行调仓时，按照先赎回后申购的方式进行调仓。先赎回的金额原则上当天进行申购基金操作，若当天申购失败，赎回资金将放在展恒基金赎回转申购账户中，在次日重新进行申购。</div>
      <div class="d3 d4">14、如果甲方购买精准理财组合后，另行买入相关成份基金的，甲方的基金交易账户内将分别登记该基金的持有份额。甲方可购买多个精准理财组合，各组合资产独立展示。</div>
      <div class="d3 d4">15、甲方理解并同意，调仓操作是由甲方提出申请。但由于甲方调仓申请存在滞后性并且不同的甲方提出调仓申请的时间存在差异，而每日精准理财下每只基金的净值存在变动，从而导致每位甲方的精准理财持仓收益和标准持仓收益之间可能存在不一致。</div>
      <div class="d3 d4">16、甲方购买精准理财组合产品，由于存在各基金的申购费用且费率各不相同，因此无法确认所申购配置的基金仓位与目标仓位完全一致，甲方应予以知悉。</div>
      <div class="d3"><span class="sp4">五、声明与承诺</span></div>
      <div class="d3 d4">1、甲方承诺其具有充分的民事行为能力和授权签署和履行本协议，按照约定参与展恒精准理财服务。 </div>
      <div class="d3 d4">2、甲方已认真阅读本协议及其附件并充分理解本协议及其附件的全部内容，明确知悉基金投资的风险及基于本协议所述服务进行基金组合投资的全部风险。 </div>
      <div class="d3 d4"><span class="sp3">2、甲方已认真阅读本协议及其附件并充分理解本协议及其附件的全部内容，明确知悉基金投资的风险及基于本协议所述服务进行基金组合投资的全部风险。 </span></div>
      <div class="d3 d4">4、甲方声明尽管其接受本协议项下的基金投资组合服务，甲方仍为展恒精准理财服务交易账户中各基金的基金份额持有人，除本协议中明确授予乙方的权利外，甲方仍享有相关基金的基金合同等法律文件赋予的权利并承担相应的义务。 </div>
      <div class="d3 d4">5、乙方承诺基于勤勉尽责、诚实信用的原则按照本协议及其附件的相关约定向甲方提供基金投资组合增值服务，不从事任何违反法律法规、本协议及其附件的行为。 </div>
      <div class="d3 d4">6、展恒精准理财服务交易账户中的基金份额属于甲方，除为本协议约定进行运作外，乙方不以任何方式挪用、拆借或侵占。 基金销售服务由北京展恒基金销售有限公司提供，您的资金将进入由民生银行监管的基金募集账户。</div>
      <div class="d3 d4">7、乙方承诺将基于诚实信用原则办理基金份额的认购、申购、赎回、转换等业务，不违反本协议的约定擅自增加甲方的义务或交易成本。 </div>
      <div class="d3"><span class="sp4">六、信息披露</span></div>
      <div class="d3 d4">1、甲方可通过乙方官方网站<span style="color:#0071DA;">（http://www.myfund.com/）</span>或展恒基金APP登陆其在乙方开立的账户查询其参与展恒精准理财服务的参与款的交纳状况、收益及对账单相关内容等。如甲方对本协议和《展恒精准理财服务协议》存在疑问，可通过拨打电话400-818-8000与展恒基金进行联系。</div>
      <div class="d3 d4">2、甲方明确知悉，甲方投资的证券投资基金及交易账户项下资产的具体资产净值，以相应基金的注册登记机构的记载为准，如甲方对展恒精准理财服务账户中的内容有任何疑问，应直接向乙方咨询。 </div>
      <div class="d3 d4">3、甲方接受展恒精准理财服务的相关信息，乙方将通过甲方事先预留的通讯方式告知甲方。甲方预留的通讯方式不准确，导致未能收到乙方通知的，乙方不承担由此造成的法律后果。 </div>
      <div class="d3 d4">4、甲方明确知悉，除甲方外，尚有他人接受本协议所述展恒精准理财服务，如需披露展恒精准理财服务相关的业务变更信息（包括但不限于业务办理时间、业务规则等的变更）适用于所有接受展恒精准理财服务的甲方，乙方可通过乙方官方网站进行披露，无需以甲方预留的方式单独通知甲方。</div>
      <div class="d3"><span class="sp4">七、风险提示</span></div>
      <div class="d3 d4">1、甲方通过乙方网上交易方式接受乙方提供的展恒精准理财服务。为确保网络传输的安全，保障甲方利益，乙方对网络资料的传输采用数据加密处理，但乙方无法保证网上信息传输绝对安全、毫无错误或指定网址不被恶意攻击或不存在因电子病毒及其他因素所导致的故障、错误等，乙方对由此造成的损失不承担任何责任，甲方须自行承担因网上交易可能导致的任何风险及损失。 </div>
      <div class="d3 d4">2、由于提供资金结算途径的银行或金融机构的系统或者人为原因，导致资金到账迟滞等问题，甚至可能导致不能及时到账，乙方可协调尽快解决，但乙方不承担由此导致的甲方损失。 </div>
      <div class="d3 d4">3、因发生不可抗力导致本协议项下展恒精准理财服务无法实施的，乙方应及时通知甲方并积极采取措施予以解决，但不承担赔偿责任。不可抗力指当事人不能预见、不能避免并不能克服的客观情况，包括但不限于战争、火灾、地震、水灾、罢工、黑客攻击、系统故障、法律法规及监管机构政策的调整等。</div>
      <div class="d3 d4">4、乙方在本协议项下提供的展恒精准理财服务需要进行基金组合投资，且投资配置详情会在精准理财产品中进行说明，甲方购买精准理财服务表示同意乙方的基金组合配置，甲方由此会承担所投资的证券投资基金的相应风险。</div>
      <div class="d3"><span class="sp4">八、协议修改、中止与终止</span></div>
      <div class="d3 d4">1、本协议的修改应由甲乙双方协商一致，但如修改内容对甲方利益无实质性不利影响的，乙方可自行修改后通知甲方。 </div>
      <div class="d3 d4">2、本协议基于以下情形中止： 甲方全部退出展恒精准理财服务。</div>
      <div class="d3 d4">3、本协议基于以下情形之一终止<br>&nbsp;&nbsp;&nbsp;&nbsp; （1）甲方以书面方式通知乙方终止本协议；<br>&nbsp;&nbsp;&nbsp;&nbsp; （2）基于法律法规或监管机构的规定或要求应当终止的。</div>
      <div class="d3"><span class="sp4">九、法律适用与争议的解决</span></div>
      <div class="d3 d4">1、本协议适用中国法律并按照中国法律解释。 </div>
      <div class="d3 d4">2、本协议的签订、履行、解释、终止及因本协议引起的任何争议，应由双方友好协商解决，协商不成的，任何一方可将争议提交于北京仲裁委员会，并按照该会届时有效的仲裁规则仲裁。仲裁裁决对双方均有法律约束力。</div>
      <div class="d3"><span class="sp4">十、协议的生效</span></div>
      <div class="d3 d4"><span class="sp3">1、甲方通过乙方网上交易平台参与展恒精准理财服务，须与乙方通过网上方式签订本协议。网上签订方式为甲方通过网上交易系统阅读并点击本协议下方的“我知道了”、“我同意”、“阅读并同意”或其他确认同意的字样/按钮，代表甲方已仔细阅读并理解本协议，完全接受其法律约束力，效力视同为甲、乙双方签字盖章。本协议自甲方签署且足额支付首次约定参与款之日起生效。 </span></div>
      <div class="d3 d4">2、本协议一经生效，即对甲乙双方具有法律约束力。本协议书签署后，若有关法律法规和《基金合同》、《招募说明书》或其他展恒基金和甲方应共同遵守的文件发生修订，本协议与之不相适应的内容及条款自行失效，但本协议其他内容和条款继续有效。本协议的部分条款无效不影响其他条款的效力。</div>
      <div class="d1">甲方：甲方</div>
      <div class="d1 d2">乙方：北京展恒基金销售股份有限公司</div>
    </div>
  </div>

</template>


<script>
export default {
  data () {
    return {
      smartMessage: ''
    }
  },
  created () {

  },
  methods: {
    returnOne () {
      const path = this.$route.params.pathName == null ? 'combinationSmartBuy' : this.$route.params.pathName
      this.$router.push({
        name: path,
        params: this.$route.params
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 1000px;
  margin: auto;
  box-sizing: border-box;
  padding: 43px 71px 41px 61px;
  h1 {
    font-size: 20px;
    font-weight: bold;
    color: rgba(17, 17, 17, 1);
    margin: auto;
    margin-bottom: 35px;
    text-align: center;
  }
  .d1 {
    font-size: 14px;
    font-weight: bold;
    color: rgba(12, 122, 193, 1);
    line-height: 22px;
    .sp2 {
      font-weight: 400;
      color: #222222;
    }
  }
  .d2 {
    margin-bottom: 25px;
  }
  .d3 {
    font-size: 14px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    text-align: justify;
    .sp4 {
      font-weight: bold;
      margin-top: 26px;
      margin-bottom: 2px;
    }
  }
  .d4 {
    margin-bottom: 18px;
    .sp3 {
      font-weight: bold;
    }
  }
}
</style>